import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7942f5c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "sec_banner"
};
const _hoisted_2 = {
  class: "banner-wrapper"
};
const _hoisted_3 = {
  class: "banner-inner"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-overlay\" data-v-7942f5c4></div><div class=\"center-graphic\" data-v-7942f5c4><img src=\"https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_RoEV0G/69c1f534e4b023103af2acc0.png\" alt=\"center\" class=\"center-img\" data-v-7942f5c4><div class=\"center-shadow\" data-v-7942f5c4></div><div class=\"center-text-group\" data-v-7942f5c4><div class=\"title\" data-v-7942f5c4>课程云</div><div class=\"subtitle\" data-v-7942f5c4>Course Cloud</div></div></div>", 2);

const _hoisted_6 = {
  class: "cards-container"
};
const _hoisted_7 = ["onClick"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 14V24H0V14C0 8.47715 4.47715 4 10 2V6C6.68629 7.5 4 10.3137 4 14H10ZM28 14V24H18V14C18 8.47715 22.4771 4 28 2V6C24.6863 7.5 22 10.3137 22 14H28Z"
}, null, -1));

const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = ["onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "sdauHelper",
  class: "sdau-helper"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.computedCards, (card, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: card._dataIndex,
      class: _normalizeClass(["floating-card", {
        active: card.active
      }]),
      onClick: $event => $options.handleCardClick(index),
      style: _normalizeStyle({
        left: card.x + 'px',
        top: card.y + 'px',
        width: card.w + 'px',
        minHeight: card.h + 'px',
        opacity: card.op,
        borderRadius: card.r + 'px',
        zIndex: card.zIndex,
        transformOrigin: card.transformOrigin || 'center center',
        transform: (card.scale ? `scale(${card.scale})` : '') + ` rotateY(${card.rotateY || 0}deg) rotateX(${card.rotateXTilt || 0}deg)`,
        background: card.active ? 'url(https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69c4ca1de4b052450123508c.png) no-repeat center center / cover' : card.bg,
        color: card.color,
        boxShadow: card.active ? '0px 6px 36px rgba(0, 0, 0, 0.12)' : card.op < 1 ? `0px ${card.r / 2}px ${card.r * 2}px rgba(0, 0, 0, 0.12)` : '0px 6px 36px rgba(0, 0, 0, 0.12)'
      })
    }, [_createElementVNode("div", {
      class: "card-inner",
      style: _normalizeStyle({
        padding: (card.active ? 16 : card.ts * 0.6) + 'px'
      })
    }, [_createElementVNode("div", {
      class: "quote-icon",
      style: _normalizeStyle({
        color: $options.getQuoteColor(card)
      })
    }, [(_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 28 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      style: _normalizeStyle({
        width: (card.active ? 28 : card.ts * 1.5) + 'px',
        height: (card.active ? 24 : card.ts * 1.2) + 'px'
      })
    }, _hoisted_9, 4))], 4), _createElementVNode("div", {
      class: "card-title",
      style: _normalizeStyle({
        fontSize: card.ts + 'px',
        lineHeight: '1.45',
        marginTop: (card.active ? 8 : card.ts * 0.3) + 'px'
      })
    }, _toDisplayString(card.title), 5), _createElementVNode("div", {
      class: "card-desc",
      style: _normalizeStyle({
        fontSize: card.ds + 'px',
        lineHeight: '1.57',
        marginTop: (card.active ? 6 : card.ts * 0.2) + 'px'
      })
    }, _toDisplayString(card.desc), 5)], 4), card.active ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "active-btn",
      style: _normalizeStyle({
        fontSize: card.ds + 'px'
      }),
      onClick: _withModifiers($event => $options.goToCourseList(card), ["stop"])
    }, " 进入 ", 12, _hoisted_10)) : _createCommentVNode("", true)], 14, _hoisted_7);
  }), 128))])])]), _hoisted_11]);
}